// extracted by mini-css-extract-plugin
module.exports = {"AbnormalPageWrapper":"AbnormalPage_AbnormalPageWrapper__TgwQF"};